const MAX_UTAG_RETRIES = 10;
const RETRY_TIMEOUT = 300;

const invokeWithRetry = (
  fn,
  condition,
  retries,
  delay,
  onFailure = () => {}
) => {
  if (condition()) {
    fn();
  } else {
    if (retries > 1) {
      setTimeout(
        () => invokeWithRetry(fn, condition, retries - 1, delay, onFailure),
        delay
      );
    } else {
      onFailure();
    }
  }
};

const isUtagLoaded = (w) => () => w?.utag && w.utag?.view && w.utag?.link;

const isDigitalDataTrackLoaded = (w) => () =>
  isUtagLoaded(w) && w?.digitalData?.track;

const digitalDataTrackPageLoad = (prefixedEventName, eventPayload) => {
  const w = window;
  invokeWithRetry(
    () => {
      w.digitalData.track(prefixedEventName, eventPayload);
    },
    isDigitalDataTrackLoaded(w),
    MAX_UTAG_RETRIES,
    RETRY_TIMEOUT
  );
};

export function trackEventWithDigitalData({
  eventName,
  eventData,
  hitType = "view",
  metaData,
}) {
  const { digitalData } = window;

  // Check if the 'digitalData' object has a 'track' function
  const prefixedEventName = `pl_${eventName}`;
  const eventPayload = { hit_type: hitType || "view", ...eventData };

  // Create the 'digitalData' object if it doesn't exist
  if (typeof digitalData === "undefined") {
    window.digitalData = {};
  }

  // Add any additional metadata to the 'digitalData' object
  window.digitalData = {
    ...window.digitalData,
    ...(metaData || {}),
  };

  // Track the event with the prefixed name and payload
  digitalDataTrackPageLoad(prefixedEventName, eventPayload);
}
